<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="AueC">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="JANUARY 13: Strength for a Failing Heart">
<h1 class="chapter" id="pAue_"><a href="#/contents#AB_ch14" id="AB_cha14">JANUARY 13<br/><br/> <span class="chapter2">Strength for a Failing Heart</span></a></h1>
<blockquote>
<p class="ext" id="pAqsD"><em>My flesh and my heart fail; but God is the strength of my heart and my portion forever.</em></p>
</blockquote>
<p class="right" id="pAPN2">—Psalm 73:26</p>
<p class="noind" id="AVMN"><span class="dcap"><b>T</b></span>he Bible doesn’t hide the pain of life on earth. In these verses the speaker’s despair is obvious. Whenever our flesh and our hearts fail, when darkness falls and storms rage in our lives—those times when we realize, <em>Where else can I turn but to God?</em>—we may find the writer of Psalm 73, Asaph, to be a welcome companion.</p>
<p id="pAKO3">Asaph knew he would find no real relief from his suffering in this world. He might not even have found someone who understood or a compassionate friend to sit with him in his pain. But despite his exhaustion Asaph could say, “God is the strength of my heart and my portion forever.” Look at what he went on to say: “It is good for me to draw near to God; I have put my trust in the Lord G<span class="smallcaps">OD</span>, that I may declare all Your works” (v. 28).</p>
<p id="pA2_">We can thank God for Asaph’s example, and that God’s Word recognizes the strain of life on earth. When our hearts break, we do well to move closer to God and “put [our] trust in the Lord,” just as this fellow believer did.</p>
<p class="left1" id="pA4KM"><em>Thank You, my trustworthy God, for always being there, offering me strength and comfort whenever I draw near.</em></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter14.vue?a30256a4